export enum ProfileEnum {
    Administrador = 0,
    GerenteDeVendas = 1,
    GerenteDeProjetos = 2,
    GerenteDeSuporte = 3,
    GerenteDeFormalizacao = 4,
    GerenteDeEstoque = 5,
    Montador = 6,
    Tecnico = 7,
    ConsultorDeVendas = 8,
    SupervisorDeVendas = 9,
    Cliente = 10,
    ConsultorDeVendasInterno = 11,
    GerenteFinanceiro = 12,
    Motorista = 13,
    Entregador = 14,
    Marketing = 15,
}

export const ProfileEnumLabel = new Map<number, string>([
    [ProfileEnum.Administrador, 'Administrador'],
    [ProfileEnum.GerenteDeVendas, 'Gerente De Vendas'],
    [ProfileEnum.GerenteDeProjetos, 'Gerente De Projetos'],
    [ProfileEnum.GerenteDeSuporte, 'Gerente De Suporte'],
    [ProfileEnum.GerenteDeFormalizacao, 'Gerente De Formalização'],
    [ProfileEnum.GerenteDeEstoque, 'Gerente De Estoque'],
    [ProfileEnum.Montador, 'Montador'],
    [ProfileEnum.Tecnico, 'Técnico'],
    [ProfileEnum.ConsultorDeVendas, 'Consultor De Vendas'],
    [ProfileEnum.SupervisorDeVendas, 'Supervisor De Vendas'],
    [ProfileEnum.Cliente, 'Cliente'],
    [ProfileEnum.ConsultorDeVendasInterno, 'Consultor De Vendas Interno'],
    [ProfileEnum.GerenteFinanceiro, 'Gerente Financeiro'],
    [ProfileEnum.Motorista, 'Motorista'],
    [ProfileEnum.Entregador, 'Entregador'],
    [ProfileEnum.Marketing, 'Marketing'],
])
